'use client'

import classNames from 'classnames'
import React, { FunctionComponent } from 'react'
import { pluralize } from '@/utils/string.utils'
import TXT from '@/messages'
// styles
import detailsListStyles from '../OrderSummary/DetailsList.module.css'
import orderSummaryStyles from '../OrderSummary/OrderSummary.module.css'
import discountCartModsStyles from './NonDiscountCartMods.module.css'

type Props = {
  mods: Transformed.CartMod[]
}

const displayName = (mod: Transformed.CartMod): React.ReactNode => {
  const transformedDisplayName = mod.name.trim().toLowerCase() !== mod.description.trim().toLowerCase()
    ? `${mod.name.trim()} - ${mod.description.trim()}`
    : mod.name.trim()

  return (
    mod.blockingCheckout
      // Only apply indented styling if there is a header (i.e. mod.blockingCheckout)
      ? (
        <div className={discountCartModsStyles.ListItemDescription}>
          {transformedDisplayName}
        </div>
      )
      : (
        <>
          {transformedDisplayName}
        </>
      )
  )
}

const NonDiscountCartMods: FunctionComponent<Props> = ({ mods }: Props) => {
  if (!mods.length) return null
  return (
    <div>
      <h2 className={classNames(
        orderSummaryStyles.GeneralTitle,
        orderSummaryStyles.MinorTitle,
      )}
      >
        {pluralize(mods.length, TXT.orderSummary.code)}
        {' '}
        {TXT.orderSummary.applied}
      </h2>
      <ul
        className={discountCartModsStyles.List}
        data-testid="non-discount-cart-mods"
      >
        {mods.map((mod) => (
          <li
            key={`mod-${mod.id}`}
            data-testid={mod.blockingCheckout ? 'blocked' : 'applied'}
            className={classNames(
              {
                // red
                [detailsListStyles.Blocked]: mod.blockingCheckout,
                // green
                [detailsListStyles.Applied]: !mod.blockingCheckout,
              },
            )}
          >
            {mod.blockingCheckout && (
              <span className={discountCartModsStyles.ListItemMain}>{TXT.orderSummary.codeRequired}</span>
            )}
            {displayName(mod)}
          </li>
        ))}
      </ul>
      <hr className="separator dark" />
    </div>
  )
}

export default NonDiscountCartMods
